import { Helmet } from "react-helmet-async";

/**
 * Organization schema emitted via Helmet on key pages.
 * Uses the same @id as the static block in index.html so Google
 * deduplicates them as a single node in the knowledge graph.
 * Keep data in sync with index.html.
 */
const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": "https://www.mind-medical.fr/#organization",
    "name": "Mind Medical",
    "legalName": "Mind Medical SAS",
    "url": "https://www.mind-medical.fr",
    "logo": "https://www.mind-medical.fr/logo-mind-medical-color.png",
    "image": "https://www.mind-medical.fr/logo-mind-medical-color.png",
    "description":
      "Agence d'intérim médical en Île-de-France avec accompagnement 100% humain.",
    "email": "recrutement@mind-medical.com",
    "telephone": "+33189715625",
    "priceRange": "€€",
    "medicalSpecialty": "Medical Staffing",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Paris",
      "addressRegion": "Île-de-France",
      "addressCountry": "FR",
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+33189715625",
      "email": "recrutement@mind-medical.com",
      "contactType": "customer service",
      "areaServed": "FR",
      "availableLanguage": ["French"],
    },
    "areaServed": {
      "@type": "Country",
      "name": "France",
    },
    "sameAs": ["https://www.linkedin.com/company/109562095"],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;
